import * as yup from 'yup'

import { requiredMessage } from 'validation/index'

export const REBIND_PROXIES_SCHEMA = yup.object().shape({
  isAllBots: yup.boolean().required(),
  proxyTags: yup
    .string()
    .trim()
    .test('notEmpty', requiredMessage, (value) => {
      if (!value) return false
      const tags = value.split(',').filter((tag) => tag.trim())
      return tags.length > 0
    })
    .required(requiredMessage),
  ignoreOriginalCountries: yup.boolean().required(),
  countryIds: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.string().required(),
        name: yup.string().required(),
      })
    ),
})

